import {createAsyncThunk} from "@reduxjs/toolkit";
import {resetPassword, signIn, signOut} from "@commons/services/authentication.api";
import {firstLoginSuccess, loginSuccess, logoutSuccess, passwordExpired, refreshSuccess, systemReady, updateUserSuccess, validateSuccess, waitingForActivation} from '../core.slice';
import {Credentials} from "@commons/mapping/Credentials";
import {LoginResultRecord} from "@commons/mapping/LoginResultRecord";
import {AxiosError} from "axios";
import {UserClass} from "@commons/mapping/UserCRUDRecord";
import {config} from "@commons/config.instance";
import {TokenRecord} from "@commons/mapping/TokenRecord";
import {patch} from "@commons/services/commons.api";
import {Trace} from "@commons/types";
import {systemInfo} from "@commons/global";
import {validateToken} from "@commons/services/token.api";

//https://blog.logrocket.com/async-await-in-typescript/
const userClasses: UserClass[] = process.env.NODE_ENV === 'development' ? ['ADMIN', 'ALIAS', 'SUPER', 'COMPANY_OPERATOR', 'EMPLOYEE'] : ['ADMIN', 'ALIAS', 'SUPER', 'COMPANY_OPERATOR'];
//const userClasses: UserClass[] = ['ADMIN', 'ALIAS', 'SUPER', 'COMPANY_OPERATOR'];
export const login = createAsyncThunk<LoginResultRecord, Credentials>(
    'auth/login',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const loginResult = await signIn(config.getBaseUrl('HR') + '/access/login', payload);
            switch (loginResult.access) {
                case 'APPROVED':
                    let classeCorretta = false;
                    if (systemInfo.appName?.toUpperCase() === 'FPNET-APP') {
                        if (loginResult.user.userClass === 'EMPLOYEE')
                            classeCorretta = true;
                    } else if (userClasses.indexOf(loginResult.user.userClass) >= 0) // Se webapp HR
                        classeCorretta = true;

                    if (classeCorretta) {
                        /*if (payload.rememberMe) {
                            setItemLocalStorage('token', loginResult.token.token);
                            setItemLocalStorage('username', loginResult.user.userName);
                        }*/
                        if (loginResult.user.emailVerificata === 2)
                            dispatch(loginSuccess({loginResult, loginOptions: {rememberMe: payload.rememberMe}}));
                        else
                            dispatch(waitingForActivation({loginResult, loginOptions: {rememberMe: payload.rememberMe}}));
                        //dispatch(firstLoginSuccess(loginResult));
                        //dispatch(passwordExpired(loginResult));
                    } else {
                        return rejectWithValue({data: {messageCode: 401, message: `Il tuo profilo utente non permette l'accesso a questa web app!`}});
                    }
                    break;

                case
                'DENIED'
                :
                    return rejectWithValue(`Accesso non riuscito! Contattare l'assistenza.`);
                    break;

                case
                'PWD_EXPIRED'
                :
                    dispatch(passwordExpired(loginResult));
                    break;

                case
                'FIRST_LOGIN'
                :
                    dispatch(firstLoginSuccess(loginResult));
                    break;
            }
            return loginResult;
        } catch
            (err) {
            const axiosError = err as AxiosError;
            return rejectWithValue(axiosError && axiosError.response ? axiosError.response : {data: {messageCode: 500, message: `Errore generico! Contattare l'assistenza`}});
        }
    }
)

export const logout = createAsyncThunk<void, string>(
    'auth/logout',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const loginResult = await signOut(config.getBaseUrl('HR') + '/access/logout', payload);
            dispatch(logoutSuccess());
            return loginResult;
        } catch (err) {
            dispatch(logoutSuccess()); // dispaccio comunque la logout success in modo da permettere una nuova login!
            return rejectWithValue('errore!')
        }
    }
)

//export const validate = createAsyncThunk<LoginResultRecord, { token: string, idAziendaMaster: number, idAzienda: number, idDip: number }>(
export const validate = createAsyncThunk<LoginResultRecord, { token: string }>(
    'auth/validate',
    async (payload, {dispatch, rejectWithValue}) => {
        /*removeItemLocalStorage('idAziendaMaster');
        removeItemLocalStorage('idAzienda');
        removeItemLocalStorage('idDip');*/
        try {
            const loginResult = await validateToken(config.getBaseUrl('HR') + '/access/login', payload.token);
            if (loginResult.access && loginResult.access !== 'DENIED') {
                if (loginResult.user.emailVerificata === 2) {
                    //const idAziendaMaster = loginResult.token.idAziendaMaster;
                    //const idAzienda = loginResult.token.idAzienda;
                    //const idDip = idAziendaMaster === payload.idAziendaMaster && idAzienda === payload.idAzienda ? payload.idDip : 0;
                    //dispatch(validateSuccess({loginResult, idAziendaMaster: idAziendaMaster, idAzienda: idAzienda, idDip: idDip}));
                    dispatch(validateSuccess({loginResult}));
                } else {
                    dispatch(waitingForActivation({loginResult}));
                }
            } else {
                dispatch(systemReady());
            }
            return loginResult;
        } catch (err) {
            return rejectWithValue('errore!')
        }
    }
)

export const refreshToken = createAsyncThunk<LoginResultRecord, string>(
    'auth/validate',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const loginResult = await validateToken(config.getBaseUrl('HR') + '/access/login', payload);
            if (loginResult.access && loginResult.access !== 'DENIED') {
                /*
                 if (loginResult.user.emailVerificata === 2) {
                    dispatch(refreshSuccess(loginResult.token.tokenExpires));
                } else
                    dispatch(waitingForActivation(loginResult));
*/
                dispatch(refreshSuccess(loginResult.token.tokenExpires));
            } else {
                dispatch(systemReady());
            }
            return loginResult;
        } catch (err) {
            return rejectWithValue('errore!')
        }
    }
)


/**
 * Azione per la richiesta dell'invio dell'email per il reset della password
 * es. url: https://fpnet2.ericed.it/FPNet2021/access/user/search?id=tntsrg71d05f704m
 */

export const resetPasswordAccount = createAsyncThunk<TokenRecord, { id: string }>(
    'auth/resetPassword',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const loginResult = await resetPassword(config.getBaseUrl('HR') + '/access/user/search', payload.id);
            return loginResult;
        } catch (err) {
            const axiosError = err as AxiosError;
            return rejectWithValue(axiosError && axiosError.response ? axiosError.response : {data: {messageCode: 500, message: `Errore generico! Contattare l'assistenza`}});
        }
    }
)

interface CambioPasswordParams {
    token: string,
    passwordInChiaro: string,
    email?: string
};

export interface CambioPasswordResult {
    idUser: number,
    userName: string,
    password: any,
    passwordInChiaro: string,
    currentPassword: any,
    oldPassword: string,
    email: any,
    emailVerificata: number,
    oldPasswordHash: string,
    lastUpdateTrace: Trace,
    id: number,
}

export const cambioPassword = createAsyncThunk<CambioPasswordResult, CambioPasswordParams>(
    'auth/cambioPassword',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const result = await patch<CambioPasswordResult>(config.getBaseUrl('HR') + `/access/user/${payload.token}`, {
                passwordInChiaro: payload.passwordInChiaro,
                email: payload.email
            });
            if (result && result.id) {
                dispatch(updateUserSuccess({email: result.email}));
            }
            return result;
        } catch (err) {
            const axiosError = err as AxiosError;
            return rejectWithValue(axiosError && axiosError.response ? axiosError.response : {data: {messageCode: 500, message: `Errore generico! Contattare l'assistenza`}});
        }
    }
)

export interface ResetAccountParams {
    idUser: number,
    passwordInChiaro: string,
    email?: string
};

export interface ResetAccountResult {
    lastUpdateTrace: Trace,
}

export const resetAccount = createAsyncThunk<ResetAccountResult, ResetAccountParams>(
    'auth/resetAccount',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const result = await patch<ResetAccountResult>(config.getBaseUrl('HR') + `/access/user/${payload.idUser}/reset-account`, {
                passwordInChiaro: payload.passwordInChiaro,
                email: payload.email
            });
            return result;
        } catch (err) {
            const axiosError = err as AxiosError;
            return rejectWithValue(axiosError && axiosError.response ? axiosError.response : {data: {messageCode: 500, message: `Errore generico! Contattare l'assistenza`}});
        }
    }
)
